import Link from "next/link"

const titles: Readonly<Record<string, string>> = {
  "APP-HOME-001": "홈",
  "APP-SHOP-001": "사용하기",
  "APP-SHOP-002": "사용하기",
  "APP-MY-001": "내 정보",
}

export const isMainTab = (routeId: string): boolean => titles[routeId] !== undefined

export const MainTabHeading = ({ routeId }: { readonly routeId: string }) => (
  <header className="main-tab-heading">
    <h1>{titles[routeId]}</h1>
    {routeId === "APP-SHOP-001" || routeId === "APP-SHOP-002" ? <Link href="/orders">주문 내역</Link> : null}
  </header>
)
